export default __webpack_public_path__ + "static/media/hht1_ep17_book_wp_02.fa557f18.jpg";